import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

const FilterBar = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const [orderNumber, setOrderNumber] = useState(searchParams.get('order_number') || '');
  const [serviceType, setServiceType] = useState(searchParams.get('service') || '');
  const [rating, setRating] = useState(searchParams.get('rating') || '');
  const [debouncedOrderNumber, setDebouncedOrderNumber] = useState(orderNumber);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedOrderNumber(orderNumber);
    }, 500);

    return () => clearTimeout(timeout);
  }, [orderNumber]);

  // useEffect(() => {
  //   const params = {};
  //   // if (orderNumber) params.order_number = orderNumber;
  //   if (debouncedOrderNumber) params.order_number = debouncedOrderNumber;
  //   if (serviceType) params.service = serviceType;
  //   if (rating) params.rating = rating;

  //   setSearchParams(params);
  // }, [debouncedOrderNumber, serviceType, rating, setSearchParams]);

  useEffect(() => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set('page', '1');

    // Update filters
    if (debouncedOrderNumber) {
      newParams.set('order_number', debouncedOrderNumber);
    } else {
      newParams.delete('order_number');
    }

    if (serviceType) {
      newParams.set('service', serviceType);
    } else {
      newParams.delete('service');
    }

    if (rating) {
      newParams.set('rating', rating);
    } else {
      newParams.delete('rating');
    }

    setSearchParams(newParams);
  }, [debouncedOrderNumber, serviceType, rating]);

  // const applyFilters = () => {
  //   const params = {};
  //   if (orderNumber) params.order_number = orderNumber;
  //   if (serviceType) params.service = serviceType;
  //   if (rating) params.rating = rating;
  //   setSearchParams(params);
  // };

  const resetFilters = () => {
    setOrderNumber('');
    setDebouncedOrderNumber('');
    setServiceType('');
    setRating('');
    setSearchParams({});
  };

  useEffect(() => {
    setOrderNumber(searchParams.get('order_number') || '');
    setServiceType(searchParams.get('service') || '');
    setRating(searchParams.get('rating') || '');
  }, [searchParams]);

  return (
    <div className="review-filter-bar">
      <div className="review-filter-group filter-order">
        <label>Nomor Order</label>
        <div className="input-with-icon">
          <input
            type="text"
            placeholder="Cari.."
            value={orderNumber}
            onChange={(e) => setOrderNumber(e.target.value)}
          />
          <span className="icon">
            <img src="/assets/icon/search-icon.svg" className="search-icon" alt="search icon" />
          </span>
        </div>
      </div>

      <div className="review-filter-group filter-service">
        <label>Jenis Layanan</label>
        <select value={serviceType} onChange={(e) => setServiceType(e.target.value)}>
          <option value="">Pilih Layanan</option>
          <option value="without_driver">Tanpa Supir</option>
          <option value="with_driver">Dengan Supir</option>
          <option value="airport_transfer">Airport Transfer - Bali</option>
          <option value="airport_transfer_sg">Airport Transfer - Singapore</option>
        </select>
      </div>

      <div className="review-filter-group">
        <label>Penilaian</label>
        <div className="rating-select">
          <select value={rating} onChange={(e) => setRating(e.target.value)}>
            <option value="">Pilih Rating</option>
            <option value="5">⭐ 5</option>
            <option value="4">⭐ 4</option>
            <option value="3">⭐ 3</option>
            <option value="2">⭐ 2</option>
            <option value="1">⭐ 1</option>
          </select>
        </div>
      </div>

      <button className="btn reset" onClick={resetFilters}>
        Reset
      </button>
      {/* <button className="btn apply" onClick={applyFilters}>
        Apply
      </button> */}
    </div>
  );
};

export default FilterBar;
